import LinkDialogCore from "@/components/ui/editor/core/components/link-dialog";
import { useEditorContext } from "../rich-text-editor-provider";

export const LinkDialog = () => {
  const { editor } = useEditorContext("Editor");
  if (!editor) return null;
  return <LinkDialogCore editor={editor} />;
};
